import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'

import { prepareData } from 'helpers/prepare-req-data'
import { prepParams } from 'helpers/prep-req-url'
import { getRespData  } from 'helpers/get-resp-data'
import client from 'api'
import _ from 'lodash'

import { v4 as uuid4 } from 'uuid'


const initialState = {
    startErlSchm200010BuStatus: 'idle',
    startErlSchm200010BuError: undefined as any,
    loadUserParamsErlSchm200010BuStatus: 'idle',
    loadUserParamsErlSchm200010BuError: undefined as any,

    erlSchm200010BuList: [] as any[],
    defaultValues: undefined as any,
    job: undefined as any,
    filterValues: {} as any,
    filterLookupValues: {} as any,

    directLoad: false,
    load: false,
    activeDivRef: null as any,

    filterValuesId: null,
    valuesFromDB: false,
    filterVisibleId: null,
    filterVisible: true,
}


export const startErlSchm200010Bu = createAsyncThunk('erlSchm200010BuSlice/startErlSchm200010Bu', async ({ erlSchm200010Bu }: any, { rejectWithValue }: any) => {
    let promises = []
    promises.push(client.post(
        `/api/ixweb/StartErlSchm200010Bu/`,
        prepareData(erlSchm200010Bu),
    ))

    const [value1Res] = await Promise.all(promises)
    const value1 = getRespData(value1Res, rejectWithValue)

    return {
        data: value1.map((x: any) => ({
            ...x,
        })),
    }
}, {
    condition: ({}: any, { getState }: any) => {
        const { startErlSchm200010BuStatus } = getState().erlSchm200010BuSlice
        return startErlSchm200010BuStatus !== 'pending'
    }
})

export const loadUserParamsErlSchm200010Bu = createAsyncThunk('erlSchm200010BuSlice/loadUserParamsErlSchm200010Bu', async (_: any, { rejectWithValue }: any) => {
    let promises = []
    promises.push(client.get(
        `/api/ixweb/LoadUserParamsErlSchm200010Bu/`,
    ))

    const [value1Res] = await Promise.all(promises)
    const value1 = getRespData(value1Res, rejectWithValue)

    return {
        data: value1.map((x: any) => ({
            ...x,
        })),
    }
}, {
    condition: ({}: any, { getState }: any) => {
        const { loadUserParamsErlSchm200010BuStatus } = getState().erlSchm200010BuSlice
        return loadUserParamsErlSchm200010BuStatus !== 'pending'
    }
})

const ErlSchm200010BuSlice = createSlice({
    name: 'erlSchm200010BuSlice',
    initialState,
    reducers: {
        resetstartErlSchm200010Bu: (state) => {
            state.job = undefined
            state.startErlSchm200010BuError = undefined
        },
        resetstartErlSchm200010BuError: (state) => {
            state.startErlSchm200010BuError = undefined
        },
        resetloadUserParamsErlSchm200010Bu: (state) => {
            state.defaultValues = undefined
            state.loadUserParamsErlSchm200010BuError = undefined
        },
        resetloadUserParamsErlSchm200010BuError: (state) => {
            state.loadUserParamsErlSchm200010BuError = undefined
        },
        removeFromErlSchm200010BuListById: (state, action) => {
            state.erlSchm200010BuList = state.erlSchm200010BuList.filter((x: any) => x.HDR_ID !== action.payload)
        },
        removeFromErlSchm200010BuListByIds: (state, action) => {
            state.erlSchm200010BuList = state.erlSchm200010BuList.filter((x: any) => action.payload.indexOf(x.HDR_ID) === -1)
        },
        setFilterValues: (state, action) => {
            if (action.payload === undefined || action.payload === null) {
                state.filterValues = {}
            } else {
                state.filterValues = { ...state.filterValues, ...action.payload }
            }
        },
        setFilterLookupValue: (state, action) => {
            const { name, value, formValue } = action.payload
            if (name) {
                state.filterLookupValues[name] = value
                state.filterValues[name] = formValue
            }
        },
        setDirectLoad: (state, action) => { state.directLoad = action.payload },
        setLoad: (state, action) => { state.load = action.payload },
        setActiveDivRef: (state, action) => { state.activeDivRef = action.payload},
        setFilterValuesId: (state, action) => {
            state.filterValuesId = action.payload
        },
        setValuesFromDB: (state, action) => {
            state.valuesFromDB = action.payload
        },
        setFilterVisibleId: (state, action) => {
            state.filterVisibleId = action.payload
        },
        setFilterVisible: (state, action) => {
            state.filterVisible = action.payload
        },
        preloadData: (state, action) => {
            state.erlSchm200010BuList = action.payload.map((x: any) => ({ ...x, HDR_ID: uuid4()}))
            state.startErlSchm200010BuStatus = 'preloaded'
        },
        clearPreloadedData: (state) => {
            state.erlSchm200010BuList = []
            state.startErlSchm200010BuStatus = 'idle'
        },
    },
    extraReducers: builder => {
        builder.addCase(startErlSchm200010Bu.pending, (state) => {
            state.startErlSchm200010BuStatus = 'pending'
            state.startErlSchm200010BuError = undefined
        })
        builder.addCase(startErlSchm200010Bu.fulfilled, (state, action) => {
            state.startErlSchm200010BuStatus = 'idle'

            {
                state.job = action.payload

            }
        })
        builder.addCase(startErlSchm200010Bu.rejected, (state, action) => {
            state.startErlSchm200010BuStatus = 'error'
            if (action.error.message !== 'Rejected') {
                state.startErlSchm200010BuError = action.error.message
            } else {
                state.startErlSchm200010BuError = action.payload
            }
        })

        builder.addCase(loadUserParamsErlSchm200010Bu.pending, (state) => {
            state.loadUserParamsErlSchm200010BuStatus = 'pending'
            state.loadUserParamsErlSchm200010BuError = undefined
        })
        builder.addCase(loadUserParamsErlSchm200010Bu.fulfilled, (state, action) => {
            state.loadUserParamsErlSchm200010BuStatus = 'idle'

            {
                state.defaultValues = action.payload

            }
        })
        builder.addCase(loadUserParamsErlSchm200010Bu.rejected, (state, action) => {
            state.loadUserParamsErlSchm200010BuStatus = 'error'
            if (action.error.message !== 'Rejected') {
                state.loadUserParamsErlSchm200010BuError = action.error.message
            } else {
                state.loadUserParamsErlSchm200010BuError = action.payload
            }
        })

    }
})

export const {
    resetstartErlSchm200010Bu,
    resetstartErlSchm200010BuError,
    resetloadUserParamsErlSchm200010Bu,
    resetloadUserParamsErlSchm200010BuError,
    removeFromErlSchm200010BuListById,
    removeFromErlSchm200010BuListByIds,
    setFilterValues,
    setFilterLookupValue,
    setDirectLoad,
    setLoad,
    setActiveDivRef,
    setFilterValuesId,
    setValuesFromDB,
    setFilterVisible,
    setFilterVisibleId,
    preloadData,
    clearPreloadedData,
} = ErlSchm200010BuSlice.actions
export default ErlSchm200010BuSlice.reducer
